import type { Profile, Skill, Service, Project } from '~/types/portfolio'

export const profile: Profile = {
  name: 'آرش رضایی',
  role: 'طراح و توسعه‌دهنده‌ی رابط کاربری',
  tagline: 'تجربه‌های وب سریع، تمیز و انسانی می‌سازم.',
  intro: 'بیش از هفت سال است که محصولات دیجیتال می‌سازم؛ از اولین اسکچ و معماری اطلاعات تا کدی که در پروداکشن اجرا می‌شود. کارم را از طراحی رابط شروع کردم و کم‌کم به سمت فرانت‌اند رفتم، چون باور دارم طراحی تا وقتی در مرورگر زنده نشود، تمام نشده است.',
  about: [
    'تمرکزم روی معماری کامپوننت، دسترس‌پذیری و حرکت‌های معنادار است — انیمیشن وقتی خوب است که چیزی را توضیح دهد، نه اینکه فقط توجه بگیرد. برای هر پروژه اول یک دیزاین‌سیستم کوچک می‌سازم تا تیم بتواند سریع و یکدست پیش برود.',
    'با Nuxt، Vue و Tailwind کار می‌کنم و به سرعت واقعی اهمیت می‌دهم: بارگذاری زیر یک ثانیه، تجربه‌ی روان روی موبایل و کدی که شش ماه بعد هم قابل خواندن باشد. راست‌چین‌بودن و تایپوگرافی فارسی هم برایم یک الزام است، نه افزوده.'
  ],
  avatar: '/images/avatar.png',
  portrait: '/images/portrait.png',
  stats: [
    { label: 'سال تجربه', value: '۷+' },
    { label: 'پروژه تحویل‌شده', value: '۶۴' },
    { label: 'رضایت کارفرما', value: '۹۸٪' }
  ],
  socials: [
    { label: 'لینکدین', href: 'https://linkedin.com/in/username', icon: 'linkedin' },
    { label: 'تلگرام', href: 'https://t.me/username', icon: 'telegram' },
    { label: 'اینستاگرام', href: 'https://instagram.com/username', icon: 'instagram' }
  ],
  contact: { email: 'hi@portify.dev', phone: '۰۹۱۲ ۰۰۰ ۰۰۰۰', city: 'تهران، ایران' }
}

export const skills: Skill[] = [
  { name: 'Vue و Nuxt', level: 95, icon: 'vue' },
  { name: 'TailwindCSS', level: 90, icon: 'tailwind' },
  { name: 'TypeScript', level: 82, icon: 'ts' },
  { name: 'GSAP / Motion', level: 78, icon: 'gsap' },
  { name: 'طراحی رابط کاربری', level: 88, icon: 'figma' }
]

export const services: Service[] = [
  { title: 'طراحی رابط و تجربه‌ی کاربری', description: 'از پژوهش و معماری اطلاعات تا پروتوتایپ قابل کلیک و دیزاین‌سیستم.', icon: 'palette' },
  { title: 'توسعه‌ی فرانت‌اند', description: 'پیاده‌سازی دقیق با Nuxt و Tailwind؛ کد ماژولار و قابل نگهداری.', icon: 'code' },
  { title: 'برند شخصی و نمونه‌کار', description: 'سایت شخصی که کار شما را درست روایت می‌کند، نه فقط فهرست می‌کند.', icon: 'spark' },
  { title: 'بهینه‌سازی سرعت و سئو', description: 'کاهش زمان بارگذاری، Core Web Vitals و ساختار داده‌ی درست.', icon: 'gauge' }
]

export const projects: Project[] = [
  {
    slug: 'shop-platform',
    title: 'پلتفرم فروشگاهی مدرن',
    summary: 'فروشگاه اینترنتی چندفروشندگی با سبد خرید لحظه‌ای.',
    description: [
      'یک پلتفرم فروشگاهی کامل با پنل فروشنده، جست‌وجوی لحظه‌ای و پرداخت چندمرحله‌ای.',
      'معماری کامپوننت‌ها طوری چیده شد که تیم بتواند بدون دست‌زدن به هسته، صفحه‌های کمپین بسازد.'
    ],
    tags: ['Nuxt', 'Pinia', 'TailwindCSS'],
    year: '۱۴۰۴', role: 'طراحی و فرانت‌اند',
    banner: '/images/projects/shop.png'
  },
  {
    slug: 'task-manager',
    title: 'اپلیکیشن مدیریت وظایف',
    summary: 'برد کانبان تیمی با همکاری همزمان.',
    description: [
      'برد کانبان با درگ‌اند‌دراپ، هم‌زمان‌سازی زنده و تاریخچه‌ی تغییرات.',
      'انیمیشن‌های GSAP برای جابه‌جایی کارت‌ها حس مکان و پیوستگی می‌سازند.'
    ],
    tags: ['Vue', 'Firebase', 'GSAP'],
    year: '۱۴۰۳', role: 'فرانت‌اند',
    banner: '/images/projects/tasks.png'
  },
  {
    slug: 'weather-dashboard',
    title: 'داشبورد آب‌وهوا',
    summary: 'پایش لحظه‌ای اقلیم با نمودارهای تعاملی.',
    description: ['نمایش داده‌های هواشناسی چند شهر با نمودار خطی و نقشه‌ی حرارتی.'],
    tags: ['Nuxt', 'Charts', 'API'],
    year: '۱۴۰۳', role: 'طراحی و فرانت‌اند',
    banner: '/images/projects/weather.png'
  },
  {
    slug: 'clinic-site',
    title: 'وب‌سایت کلینیک زیبایی',
    summary: 'رزرو نوبت آنلاین و معرفی خدمات.',
    description: ['سایت معرفی و نوبت‌دهی با فرم چندمرحله‌ای و تقویم شمسی.'],
    tags: ['Vue', 'SSR', 'SEO'],
    year: '۱۴۰۲', role: 'فرانت‌اند',
    banner: '/images/projects/clinic.png'
  },
  {
    slug: 'design-system',
    title: 'دیزاین‌سیستم محصول',
    summary: 'کتابخانه‌ی کامپوننت با مستندات زنده.',
    description: ['۴۸ کامپوننت، توکن‌های رنگ و تایپ، و مستندات تعاملی برای تیم ده‌نفره.'],
    tags: ['Design System', 'Storybook'],
    year: '۱۴۰۲', role: 'سرپرست طراحی',
    banner: '/images/projects/ds.png'
  },
  {
    slug: 'restaurant',
    title: 'منوی دیجیتال رستوران',
    summary: 'منوی QR با سفارش سرمیزی.',
    description: ['منوی دیجیتال سبک با سفارش سرمیزی و پرداخت درجا.'],
    tags: ['Nuxt', 'PWA'],
    year: '۱۴۰۱', role: 'طراحی و فرانت‌اند',
    banner: '/images/projects/food.png'
  }
]
